(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-1"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-4"]) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuby-agent-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  async function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const list = root.querySelector('[data-agent-list]');
    const pager = root.querySelector('[data-agent-pages]');
    let next = root.querySelector('[data-agent-next]')?.getAttribute('href');
    const visited = new Set();
    try {
      while (next) {
        const url = new URL(next, location.href);
        url.searchParams.set('view', 'general-contact');
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid directory page');
        visited.add(url.href);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Directory unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-agent-directory]');
        if (!page) throw new Error('Directory missing');
        const ids = new Set([...list.querySelectorAll('[data-agent-card]')].map(card => card.dataset.agentId));
        page.querySelectorAll('[data-agent-card]').forEach(card => { if (!ids.has(card.dataset.agentId)) list.append(card); });
        next = page.querySelector('[data-agent-next]')?.getAttribute('href');
      }
    } catch { return; }
    const cards = [...list.querySelectorAll('[data-agent-card]')];
    if (!cards.length) { root.hidden = true; return; }
    const search = root.querySelector('[data-agent-search]');
    const region = root.querySelector('[data-agent-region]');
    [...new Set(cards.map(card => card.dataset.region))].sort((a,b) => a.localeCompare(b)).forEach(value => region.add(new Option(value,value)));
    const entries = cards.map(card => ({card,text:normalize(card.textContent)}));
    const update = () => {
      const query = normalize(search.value);
      let count = 0;
      entries.forEach(({card,text}) => {
        const visible = (!query || text.includes(query)) && (!region.value || card.dataset.region === region.value);
        card.hidden = !visible;
        if (visible) count++;
      });
      root.querySelector('[data-agent-count]').textContent = String(count);
      root.querySelector('[data-agent-empty]').hidden = count !== 0;
    };
    search.addEventListener('input',update);
    region.addEventListener('change',update);
    root.querySelector('[data-agent-reset]').addEventListener('click',() => { search.value=''; region.value=''; update(); search.focus(); });
    root.querySelector('[data-agent-filters]').hidden = false;
    root.querySelector('[data-agent-status]').hidden = false;
    pager.hidden = true;
    update();
  }
  const boot = () => document.querySelectorAll('[data-agent-directory]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuby-home"]) return;
  try {
    

(function(){
 function init(root){root.querySelectorAll('[data-kr-cinema]').forEach(function(hero){
  if(hero.dataset.ready)return;hero.dataset.ready='true';
  var video=hero.querySelector('video'),button=hero.querySelector('[data-kr-video-toggle]');
  var motion=matchMedia('(prefers-reduced-motion: reduce)'),saveData=navigator.connection&&navigator.connection.saveData;
  var userPaused=false,resume=false;
  var dialog=hero.querySelector('[data-kr-film-dialog]'),film=hero.querySelector('[data-kr-film-player]'),opener=hero.querySelector('[data-kr-film-open]'),wasPlaying=false;
  if(dialog&&film&&opener){opener.addEventListener('click',function(){wasPlaying=!video.paused;video.pause();dialog.showModal();film.play().catch(function(){});});dialog.querySelector('[data-kr-film-close]').addEventListener('click',function(){dialog.close();});dialog.addEventListener('click',function(e){if(e.target===dialog){var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',function(){film.pause();if(wasPlaying&&!userPaused&&!motion.matches)play();opener.focus();});}

  function sync(){var playing=!video.paused;var french=document.documentElement.lang.indexOf('fr')===0;button.setAttribute('aria-label',playing?(french?'Mettre la vidéo en pause':'Pause video'):(french?'Lire la vidéo':'Play video'));button.setAttribute('aria-pressed',String(playing));var icon=playing?'Ⅱ':'▶';if(button.firstElementChild.textContent!==icon)button.firstElementChild.textContent=icon;}
  var sourceReady=false;
  function loadVideo(){
    if(sourceReady)return;
    sourceReady=true;
    video.querySelectorAll('source[data-src]').forEach(function(source){source.src=source.dataset.src;});
    video.load();
  }
  function play(){loadVideo();video.play().catch(sync);}
  video.addEventListener('playing',function(){hero.classList.add('kr-cinema-has-video');},{once:true});
  video.muted=true;video.addEventListener('play',sync);video.addEventListener('pause',sync);video.addEventListener('error',function(){button.hidden=true;});
  button.addEventListener('click',function(){if(video.paused){userPaused=false;play();}else{userPaused=true;video.pause();}});
  motion.addEventListener('change',function(e){if(e.matches)video.pause();});
  document.addEventListener('visibilitychange',function(){if(document.hidden){resume=!video.paused;video.pause();}else if(resume&&!userPaused&&!motion.matches&&!(dialog&&dialog.open))play();});
  new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});
  function startAutoplay(){
    function ready(){
      if(video.isConnected&&(!matchMedia('(max-width: 900px)').matches||video.hasAttribute('data-mobile-auto-play'))&&video.hasAttribute('data-auto-play')&&!motion.matches&&!saveData&&!userPaused&&video.paused&&!document.hidden&&!(dialog&&dialog.open))play();
    }
    if('requestIdleCallback' in window)window.requestIdleCallback(ready,{timeout:2000});
    else window.requestAnimationFrame(function(){window.requestAnimationFrame(ready);});
  }
  sync();
  if(document.readyState==='complete')startAutoplay();
  else window.addEventListener('load',startAutoplay,{once:true});
 });}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kuby-rqra"]) return;
  try {
    
(function(){
 document.querySelectorAll('[data-rqra-form]').forEach(function(form){
  if(form.dataset.ready)return;form.dataset.ready='true';
  var button=form.querySelector('[type="submit"]'),error=form.querySelector('[data-rqra-error]'),fr=form.dataset.language.startsWith('fr');
  var requestId=crypto.randomUUID();button.disabled=false;
  form.addEventListener('submit',async function(event){
   event.preventDefault();if(button.disabled||!form.reportValidity())return;
   button.disabled=true;error.hidden=true;form.setAttribute('aria-busy','true');
   var data=new FormData(form),get=function(key){return String(data.get('contact['+key+']')||'').trim();};
   var body={requestId:requestId,name:get('name'),email:get('email'),residence:get('Residence'),city:get('Ville'),phone:get('phone'),role:get('Fonction'),message:get('body'),need:get('Besoin'),interest:get('Interet').replace('_option',''),followup:get('Suivi souhaite'),language:fr?'fr':'en',website:String(data.get('website')||'')};
   try{
    var response=await fetch(form.dataset.endpoint,{method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:AbortSignal.timeout(20000)});
    var result=await response.json();if(!response.ok||result.ok!==true)throw new Error(response.status===429?'rate':'save');
    form.querySelector('[data-rqra-fields]').hidden=true;var success=form.querySelector('[data-rqra-success]');success.hidden=false;success.focus();form.reset();
   }catch(e){error.textContent=e.message==='rate'?(fr?'Trop de tentatives. Réessayez un peu plus tard ou parlez à notre représentante.':'Too many attempts. Please try later or speak with our representative.'):(fr?'L’enregistrement n’a pas été confirmé. Vos réponses sont conservées à l’écran; réessayez ou parlez à notre représentante.':'Your request could not be confirmed. Your answers remain on screen; please retry or speak with our representative.');error.hidden=false;error.focus();button.disabled=false;}
   finally{form.removeAttribute('aria-busy');}
  });
 });
})();

  } catch(e) { console.error(e); }
})();
})();
